<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>
</div>

<p-fieldset>

    <!-- <ng-template pTemplate="header">    </ng-template> -->
    <p-toolbar styleClass="p-mb-4">
        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="goBack()"></button>
    </p-toolbar>
    <div class="card">

        <p-table #dt [value]="usuarioDocList" [rows]="20" [paginator]="true"
            [globalFilterFields]="['login','name','email']" [(selection)]="selectedUsuario" [rowHover]="true"
            dataKey="login" styleClass="p-datatable-responsive-demo"
            currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
            [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll" responsive="true">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">{{this.lbl_users}} {{findOptInput}} </h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{lbl_search}}" />
                    </span>
                </div>

                <span class="p-input-icon-left">
                    <button type="button" *ngIf="security && security.levelId=='I'" pButton pRipple icon="pi pi-plus"
                        (click)="createUser()" class="p-mr-4" pTooltip="{{lbl_new_record}}"
                        tooltipPosition="bottom"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                        class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                </span>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="login">{{this.lbl_login}}<p-sortIcon field="login"></p-sortIcon></th>
                    <th pSortableColumn="name">{{this.lbl_name}}<p-sortIcon field="name"></p-sortIcon></th>
                    <!-- <th pSortableColumn="lastName">{{this.lbl_last_name}}<p-sortIcon field="lastName"></p-sortIcon></th> -->
                    <!-- <th pSortableColumn="clave">Clave<p-sortIcon field="clave"></p-sortIcon></th>  -->
                    <th pSortableColumn="rol">{{this.lbl_type}}<p-sortIcon field="rol"></p-sortIcon></th>
                    <th pSortableColumn="guideId">{{this.lbl_guideId}}<p-sortIcon field="guideId"></p-sortIcon></th>
                    <th pSortableColumn="email">{{this.lbl_email}}<p-sortIcon field="email"></p-sortIcon></th>
                    <th pSortableColumn="email">{{this.lbl_status}}<p-sortIcon field="email"></p-sortIcon></th>
                    <th *ngIf="security && security.levelId=='I'" pSortableColumn="supplId">
                        {{this.lbl_vendor}}<p-sortIcon field="supplId"></p-sortIcon></th>
                    <!-- <th pSortableColumn="cellPhone">Celular<p-sortIcon field="cellPhone"></p-sortIcon></th> -->
                    <!--  <th pSortableColumn="language">Idioma<p-sortIcon field="language"></p-sortIcon></th> -->
                    <!-- <th pSortableColumn="function">Función<p-sortIcon field="function"></p-sortIcon></th> -->
                    <!-- <th pSortableColumn="function">Tipo<p-sortIcon field="function"></p-sortIcon></th> -->
                    <th *ngIf="security && security.levelId!='L'">{{this.lbl_edit}}</th>
                    <th *ngIf="security && security.levelId=='I'">{{this.lbl_delete_record}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr>
                    <td>{{user.login}}</td>
                    <td>{{user.gui ? user.gui.guiType : ''}} {{user.name}} {{user.lastName}}</td>
                    <!-- <td></td> -->
                    <!-- <td>{{user.clave}}</td> -->
                    <td>{{user.rol}}</td>
                    <td>{{user.guideId}}</td>
                    <td> {{user.gui ? user.gui.email : user.email}}</td>
                    <td>{{user.status}}</td>
                    <td *ngIf="security && security.levelId=='I'">{{user.supplId}}</td>
                    <!-- <td>{{user.cellPhone}}</td> -->
                    <!-- <td>{{user.language != null ? user.language : ""}}</td> -->
                    <!-- <td>{{user.function}}</td> -->
                    <!-- <td>{{user.type}}</td> -->
                    <td *ngIf="security && security.levelId!='L'">
                        <button type="button" pButton pRipple icon="pi pi-pencil"
                            class="p-button-rounded p-button-success mr-2" (click)="editUser(user)"></button>
                    </td>
                    <td *ngIf="security && security.levelId=='I'">
                        <button type="button" pButton pRipple icon="pi pi-trash"
                            class="p-button-rounded p-button-warning" (click)="deleteUsuario(user)"></button>
                    </td>

                </tr>
            </ng-template>

            <ng-template pTemplate="summary">
                <div class="p-d-flex p-ai-center p-jc-between">
                    {{lbl_total}} {{usuarioDocList ? usuarioDocList.length : 0 }} {{lbl_records}}.
                </div>
            </ng-template>
        </p-table>


    </div>

    <!-- <p-dialog [(visible)]="optionDialog" [style]="{width: '550px'}" header="Detalle Usuario" [modal]="true" styleClass="p-fluid" (onShow)="onShowModalOption()">   -->
    <p-dialog [(visible)]="optionDialog" [style]="{width: '550px'}" header="{{lbl_detail}} {{lbl_user}}" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">

            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="Habilitar" *ngIf="userView && userView.status=='B'"
                        icon="pi pi-check-circle" class="p-button-success p-mr-2" (click)="enable()"></button>
                </ng-template>
            </p-toolbar>
            <div class="field p-text-bold">
                <label for="opt">{{lbl_type}}</label>
                <p-dropdown [options]="listUserTypes" [(ngModel)]="selectedUserType" optionLabel="value"
                    [showClear]="true" placeholder="Selecione tipo" (onChange)="showSupplOrGuide()"
                    [disabled]="tmpPassword"></p-dropdown>
            </div>


            <div class="field p-text-bold">
                <label for="opt" *ngIf='showGuides'>{{lbl_guideId}}</label>
                <p-autoComplete *ngIf='showGuides' panelStyleClass="panelTest" class="mdb-autocomplete"
                    [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" id="selectedGuide"
                    [(ngModel)]="selectedGuide" [suggestions]="filteredGuides" (completeMethod)="filterGui($event)"
                    field="name" [minLength]="1" [dropdown]="true" autoWidth="false"
                    [disabled]="tmpPassword"></p-autoComplete>
            </div>
            <div class="field p-text-bold">
                <label for="opt" *ngIf='showSuppliers'>{{lbl_vendor}}</label>
                <p-dropdown *ngIf='showSuppliers' [options]="lstSuppliers" [(ngModel)]="selectedSupplier"
                    optionLabel="name" [showClear]="true" placeholder="{{lbl_select}} {{lbl_vendor}}"
                    [disabled]="tmpPassword"></p-dropdown>
            </div>


            <div class="field p-text-bold">
                <label for="opt" *ngIf='!showGuides && !showSuppliers'>{{lbl_name}}</label>
                <input type="text" *ngIf='!showGuides && !showSuppliers' pInputText id="name"
                    [(ngModel)]="userView.name" required autofocus maxlength="30" />
                <small class="p-error" *ngIf="submitted && !userView.name">{{lbl_entry}} {{lbl_name}}</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt" *ngIf='!showGuides && !showSuppliers'>{{lbl_last_name}}</label>
                <input type="text" *ngIf='!showGuides && !showSuppliers' pInputText id="name"
                    [(ngModel)]="userView.lastName" required autofocus maxlength="35" />
                <small class="p-error" *ngIf="submitted && !userView.lastName">{{lbl_entry}} {{lbl_last_name}}</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt">{{lbl_userId}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="userView.login" required autofocus maxlength="15"
                    [disabled]="tmpPassword" />
                <small class="p-error"
                    *ngIf="submitted && userView && (!userView.login || userView.login && userView.login.length < 6)">{{lbl_entry}} {{lbl_userId}}</small>
            </div>
            <div class="field p-text-bold">
                <label for="clave">{{lbl_password}}</label>
                <input type="password" pInputText id="clave" [(ngModel)]="userView.clave" required autofocus
                    maxlength="15" />
                <small class="p-error"
                    *ngIf="submitted && userView && (!userView.clave || userView.clave && userView.login.length < 6)">{{lbl_entry}}
                    {{lbl_password}}</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt" *ngIf='!showGuides && !showSuppliers'>{{this.lbl_email}}</label>
                <input type="text" *ngIf='!showGuides && !showSuppliers' pInputText id="name"
                    [(ngModel)]="userView.email" required autofocus maxlength="50" />

            </div>


        </ng-template>

        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{this.lbl_back}}" icon="pi pi-times" class="p-button-text"
                (click)="hideDialog()"></button>
            <button pButton pRipple label="{{this.lbl_save}}" icon="pi pi-check" class="p-button-text"
                (click)="createUsuario()"></button>
        </ng-template>
    </p-dialog>

</p-fieldset>